const img_endpoint = ""

export default img_endpoint;